import { render, staticRenderFns } from "./ServiceConfiguration.vue?vue&type=template&id=18a81c54"
import script from "./ServiceConfiguration.vue?vue&type=script&lang=js"
export * from "./ServiceConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports